module.exports = __webpack_public_path__ + "img/黄浦区南京街道敬老院3.76b98917.jpeg";